import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import hi from './locales/hi.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      hi: { translation: hi }
    },
    // 🔥 DEFAULT LANGUAGE SET TO HINDI (हिंदी)
    lng: localStorage.getItem('language') || 'hi',
    fallbackLng: 'hi',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    react: {
      useSuspense: false
    }
  });

// Listen for language changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
  document.documentElement.setAttribute('lang', lng);
  // Set document direction for RTL support (if needed in future)
  if (lng === 'hi') {
    document.documentElement.setAttribute('dir', 'ltr'); // Hindi is LTR
  }
});

export default i18n;
